import { ExternalLink, Star } from "lucide-react";
import { GOOGLE_REVIEWS_CONFIG } from "../data/googleReviewsConfig";

/**
 * Always shows its fallback state today (GOOGLE_REVIEWS_CONFIG is null,
 * see that file) — which honestly satisfies the AC's "graceful fallback if
 * the widget fails to load" requirement, since there's nothing real to
 * load yet. Not building a speculative async script-loader against an
 * unknown embed provider's API shape — that would be scaffolding around a
 * guess, not a real integration; the actual loading logic should be
 * written once a real Google Business Profile and embed method are known.
 */
export default function GoogleReviewsWidget() {
  if (!GOOGLE_REVIEWS_CONFIG) {
    return (
      <div className="mx-auto max-w-md rounded-2xl bg-foam-100 p-6 text-center">
        <Star className="mx-auto h-5 w-5 text-ocean-800/30" strokeWidth={1.5} />
        <p className="mt-2 text-sm text-ocean-800/60">
          Google reviews will appear here once our Business Profile is live.
        </p>
      </div>
    );
  }

  return (
    <a
      href={GOOGLE_REVIEWS_CONFIG.profileUrl}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700"
    >
      See our Google reviews
      <ExternalLink className="h-3.5 w-3.5" />
    </a>
  );
}
